import { arrayOf, bool, number, oneOfType, shape, string } from 'prop-types'

export const FactsType = arrayOf(
  shape({
    display: shape({
      date: shape({
        day: number,
        isApproximate: bool,
        month: number,
        normalized: oneOfType([string, number]),
        year: number,
      }),
      place: string,
      placeFull: string,
      type: string,
    }),
    data: string,
    dateDescription: string,
    latLong: shape({
      latitude: number.isRequired,
      longitude: number.isRequired,
    }),
    placeDescription: string,
    type: string,
  }).isRequired
)

export const PersonType = shape({
  personId: string,
  name: string,
  surname: string,
  birth: string,
  death: string,
  dob: number,
  dod: number,
  atn: number,
  gender: string,
  lifespan: string,
  living: bool,
  facts: FactsType,
  defaultIconUrl: string,
  genderIconUrl: string,
  latLong: shape({
    latitude: number,
    longitude: number,
    name: string,
    placeId: string,
  }),
  portraitThumbnail: string,
})
